import { priceDisplay } from "./priceDisplay";
import i18n from "@/i18n";
import { utils } from "klinecharts";
import { Toast } from "vant";

class common {
  constructor() { }

  // 数值处理（万、亿） 保留两位小数
  // decimalPlaces 保留几位小数
  numberHandler(val, decimalPlaces = 2) {
    if (!val) return val;
    if (i18n.locale == 'zh_CN' || i18n.locale == 'zh_TW') {
      val = val.toString().indexOf('e') == '-1' ? Number(val) : Number(val.toString().slice(0, 10))
      if ((val >= 10000 && val < 100000000) || (val <= -10000 && val > -100000000)) {
        val = this.fixedDecimalPlaces(val / 10000, decimalPlaces) + i18n.tc('common.tenThousand');
      }
      if (val >= 100000000) {
        val = this.fixedDecimalPlaces(val / 100000000, decimalPlaces) + i18n.tc('common.hundredMillion');
      }
      return typeof val == 'number' ? this.fixedDecimalPlaces(val, decimalPlaces) : val;
    } else {
      let negative = '';
      if (val < 0) {
        val = val.toString().slice(1);
        negative = '-';
      }
      const units = [
        { threshold: 1e9, unit: 'B' }, // B代表十亿
        { threshold: 1e6, unit: 'M' }, // M代表百万
        { threshold: 1e3, unit: 'K' }, // K代表千
        { threshold: 1, unit: '' }     // 没有单位的情况
      ];
      for (let unit of units) {
        if (val >= unit.threshold) {
          let lsDecimalPlaces = this.getNonzeroDecimalNum(val / unit.threshold, decimalPlaces);
          return `${negative}${lsDecimalPlaces - decimalPlaces >= 3 ? utils.formatFoldDecimal(this.fixedDecimalPlaces(val / unit.threshold, this.getNonzeroDecimalNum(val / unit.threshold, decimalPlaces)), 0) : this.fixedDecimalPlaces(val / unit.threshold, decimalPlaces)}${unit.unit}`;
        }
      }
      return `${negative}${this.getNonzeroDecimalNum(val, decimalPlaces) > decimalPlaces ? utils.formatFoldDecimal(this.fixedDecimalPlaces(val, this.getNonzeroDecimalNum(val, decimalPlaces)), 0) : this.fixedDecimalPlaces(val, decimalPlaces)}` | 0;
    }
  }

  // Display precision is separate from the raw trading amount.
  priceZeroHandler(val, decimalPlaces = 4) {
    return priceDisplay(val, decimalPlaces);
  }

  // 保留小数 不四舍五入
  fixedDecimalPlaces(num, decimalPlaces = 4) {
    if (!num) return num;
    const numStr = num.toString();
    const decimalIndex = numStr.indexOf('.');
    if (decimalIndex === -1 || numStr.length - decimalIndex - 1 < decimalPlaces) {
      return numStr;
    }
    const decimalPart = numStr.substring(decimalIndex + 1, decimalIndex + 1 + decimalPlaces);
    const padding = '0'.repeat(Math.max(0, decimalPlaces - decimalPart.length));
    const integerPart = numStr.substring(0, decimalIndex || numStr.length);
    return `${integerPart}.${padding}${decimalPart}`;
  }

  // 获取非0的小数 位数
  // decimalPlaces 几位小数
  getNonzeroDecimalNum(number, decimalPlaces) {
    if (!number) return number;
    let numStr = number.toString();
    let regex;
    if (decimalPlaces == 2) {
      regex = /^\d+\.(\d*?[1-9]\d{1}|\d{3,})/;
    } else if (decimalPlaces == 3) {
      regex = /^\d+\.(\d*?[1-9]\d{2}|\d{3,})/;
    } else if (decimalPlaces == 4) {
      regex = /^\d+\.(\d*?[1-9]\d{3}|\d{3,})/;
    }
    let match = numStr.match(regex);
    if (match) {
      let decimalPart = match[1];
      return decimalPart.length;
    }
    return 0;
  }
  // 获取非0的小数 位数
  // k 线
  getNonzeroDecimal(number, decimalPlaces = 4) {
    if (!number) return number;
    let decimal = number.toString().split('.')[1];
    let returnNum = 0;
    if (decimal) {
      if (decimal.length <= 4) {
        returnNum = decimal.length;
      } else {
        let num = 0;
        for (let i = 0; i < decimal.split('').length; i++) {
          if (decimal[i] === '0') {
            num++
          } else {
            break;
          }
        }
        returnNum = num + decimalPlaces;
      }
    }
    return returnNum;
  }

  // 日期处理
  dateFormat(val, type = 'YYYY-MM-DD HH:mm') {
    if (val) {
      let date = new Date(val);
      switch (type) {
        case 'YYYY-MM-DD':
          return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
        case 'YYYY-MM-DD HH:mm':
          return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        case 'HH:mm':
          return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        case 'HH:mm:ss':
          return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
        case 'MM-DD HH:mm':
          return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        case 'MM-DD':
          return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
        default:
          return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
      }
    } else {
      return '';
    }
  }

  // 官网展示：只显示主域名
  websiteHost(url) {
    if (!url) return '';
    let host = '';
    try {
      host = new URL(url.startsWith('http') ? url : `https://${url}`).hostname;
    } catch (e) {
      host = url.replace(/^https?:\/\//i, '').split('/')[0];
    }
    host = host.replace(/^www\./i, '');
    const parts = host.split('.').filter(Boolean);
    if (parts.length > 2) {
      return parts.slice(-2).join('.');
    }
    return host;
  }

  // 复制内容到粘贴板
  copyToClipboard(val) {
    let tag = document.createElement('input');
    tag.setAttribute('id', 'cp_hgz_input');
    tag.value = val;
    document.getElementsByTagName('body')[0].appendChild(tag);
    document.getElementById('cp_hgz_input').select();
    document.execCommand('copy');
    document.getElementById('cp_hgz_input').remove();
    Toast.success(i18n.tc('common.copySuccess'));
  }
}

export default new common();